<template>
  <div class="p-front__content">
    <h1>Error</h1>
    <div>
      <br/>
        <b-button v-show="!$can('anon')" @click="logout" size="md" variant="danger">
          Logout
        </b-button>
         <!-- {{ $can('anon') }} -->
      <!-- <br> -->
        <b-button v-show="$can('anon')" @click="login" size="md" variant="primary">
          Login
        </b-button>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";
export default {
  name: "error_page",
  methods: {
    ...mapActions(["setAccess"]),
    logout() {
      this.setAccess("anon");
      this.access = "anon";
      setTimeout(() => {
        this.$router.push({ path: "/auth/login" });
      }, 700);
    },
    login() {
      this.$router.push({ path: "/auth/login" });
    }
  }
};
</script>
<style scoped>
.p-signin-a__form-links {
  text-align: center;
  color: #0094f2;
}

.p-signin-a__form-link a.link-info {
  text-decoration: none;
}

.p-signin-a__form-link {
  margin-top: 0px;
  font-size: 14px;
}

.p-signin-a__form-link:first-child {
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Error.vue